export default __webpack_public_path__ + "static/media/megaphone.06fd862a.png";